import { Injectable } from '@angular/core';
import { BasePainterOptions, ImagePositionInformation, PainterImage } from '@shared/models/painter';
import { CellData } from '../items-data-fetcher.service';

@Injectable()
export class PainterService {
    paintForModal(cellData: CellData, canvas: fabric.StaticCanvas, imagePosition?: ImagePositionInformation, options?: BasePainterOptions): void {}
    paintForFeed(cellData: CellData, image: PainterImage, imagePosition?: ImagePositionInformation, options?: BasePainterOptions): void {}
}
